import { type FC } from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { MoonLoader } from "react-spinners";
import { ModalDeleteRuta } from "../../modals/ModalDeleteRuta/ModalDeleteRuta";
import { ModalEditRuta } from "../../modals/ModalEditRuta/ModalEditRuta";
import { VerDetallesRutasModal } from "../../modals/VerDetallesRutasModal/VerDetallesRutasModal";
import { calcularSaldoActualRuta } from "../../../utils/rutaMovimientos";
import type { SelectedRuta as ModalEditRutaSelectedRuta } from "../../modals/ModalEditRuta/types";
import { useTablaAdministradores } from "./tablaAdministradoresHooks";

const EMPTY_STATE_COLSPAN = 8;

export const TablaAdministradores: FC = () => {
  const {
    formatearNumeros,
    handleDeleteClick,
    handleEditClick,
    handleRadioChange,
    handleVerDetallesClick,
    rutasData,
    selectedRuta,
    submittingRutaUid,
    setSelectedRuta,
    setShowModalDelete,
    setShowModalEdit,
    setVerDetalles,
    showModalDelete,
    showModalEdit,
    verDetalles,
  } = useTablaAdministradores();

  return (
    <>
      {verDetalles ? (
        <VerDetallesRutasModal
          setVerDetalles={setVerDetalles}
          selectedRuta={selectedRuta}
          setSelectedRuta={setSelectedRuta}
        />
      ) : null}

      {showModalDelete ? (
        <ModalDeleteRuta
          setShowModalDelete={setShowModalDelete}
          selectedRuta={selectedRuta}
        />
      ) : null}

      {showModalEdit ? (
        <ModalEditRuta
          selectedRuta={selectedRuta as ModalEditRutaSelectedRuta | null}
          setShowModalEdit={setShowModalEdit}
        />
      ) : null}

      <table className="min-w-full mt-4 bg-white">
        <thead>
          <tr className="bg-[#8131bd] text-white">
            <th className="border border-black w-6 px-2 py-1">#</th>
            <th className="border border-black w-10 px-2 py-1">Ruta</th>
            <th className="border border-black w-10 px-2 py-1">Responsable</th>
            <th className="border border-black w-10 px-2 py-1 whitespace-nowrap">
              Saldo Actual
            </th>
            <th className="border border-black w-10 px-2 py-1">Editar</th>
            <th className="border border-black w-10 px-2 py-1">Eliminar</th>
            <th className="border border-black w-10 px-2 py-1 whitespace-nowrap">
              Cambiar Senha
            </th>
            <th className="border border-black w-10 px-2 py-1">Detalles</th>
          </tr>
        </thead>
        <tbody>
          {rutasData.length > 0 ? (
            rutasData.map((item, index) => (
              <tr
                key={item.uid ?? index}
                className={`${
                  index % 2 === 0 ? "bg-gray-300" : "bg-gray-100"
                } border border-black`}
              >
                <td className="border border-black text-center px-2 py-1 font-semibold">
                  {index + 1}
                </td>
                <td className="items-center border-black flex justify-center px-1 py-1 font-semibold">
                  {item.nombreRuta}
                </td>
                <td className="border border-black px-2 whitespace-nowrap text-center py-1 uppercase font-semibold">
                  {item.responsable}
                </td>
                <td className="border border-black px-2 whitespace-nowrap text-center py-1 uppercase font-semibold">
                  R${formatearNumeros(calcularSaldoActualRuta(item))}
                </td>

                <td className="border border-black w-10 text-center px-2 py-1 font-semibold">
                  <AiOutlineEdit
                    onClick={() => handleEditClick(item)}
                    className="cursor-pointer my-0 mx-auto"
                  />
                </td>

                <td className="border border-black w-10 px-2 py-1 font-semibold">
                  <AiOutlineDelete
                    className="cursor-pointer my-0 mx-auto"
                    onClick={() => handleDeleteClick(item)}
                  />
                </td>

                <td className="border border-black w-10 px-2 py-1">
                  {submittingRutaUid === item.uid ? (
                    <div className="w-full flex justify-center">
                      <MoonLoader size={16} color="#000" />
                    </div>
                  ) : (
                    <input
                      type="checkbox"
                      checked={Boolean(item.isAutorized)}
                      onChange={() => handleRadioChange(item)}
                      disabled={submittingRutaUid !== null}
                      className="my-0 mx-auto w-full"
                    />
                  )}
                </td>

                <td
                  onClick={() => handleVerDetallesClick(item)}
                  className="border cursor-pointer underline border-black px-2 whitespace-nowrap text-center py-1 font-semibold"
                >
                  Ver
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={EMPTY_STATE_COLSPAN}>No hay datos disponibles.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};
